import React, { memo, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import ThumbsGallery from "./home/ThumbsGallery";
import {
    GetRecVideoList,
    GetNewVideoList,
    GetRecommendProfessionalList,
    GetVideoListByUser,
} from "../../../common/homePage/HomePageActions";
import stylesPc from "./HomePage.module.css";
import stylesSp from "./HomePage_SP.module.css";
import { filterVideoList } from "../../../common/video/VideoActions";
import PuiTypography from "../../../components/elements/PuiTypography";
import VideoSlideGroup from "../../../common/components/slide/VideoSlideGroup";
import PresenterSlideGroup from "../../../common/components/slide/PresenterSlideGroup";
import { CircularProgress } from "@material-ui/core";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import { useInitFlag } from "../../../components/function/useInitFlag";

function HomePage() {
    const dispatch = useDispatch();
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const { userInfo, isLoading } = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo,
        isLoading: state.recommendList.isLoading,
    }));

    // おすすめビデオ
    const { list, videos } = useSelector(({ recommendList }: AppState) => recommendList);
    const videoIds = useMemo(() => (list.length >= 1 ? list : undefined), [list]);

    // ３行リスト
    const { newVideoList, recommendProfessionalList } = useSelector(
        ({ recommendList }: AppState) => recommendList
    );

    // 視聴履歴
    const { userVideos } = useSelector(({ recommendList }: AppState) => recommendList);
    // データ取得中フラグ
    const [isLoadingData, setIsLoadingData] = useInitFlag(true);
    // 初期化フラグ
    const [isInit, setIsInit] = useInitFlag(true);

    // ログインユーザーの視聴履歴
    useEffect(() => {
        const videoFilter = {
            id: [],
            professional: [],
            program: [],
            project: [],
            tag: [],
        };
        if (userInfo) {
            dispatch(GetRecommendProfessionalList(parseInt(userInfo.id)));
            dispatch(GetRecVideoList(userInfo.id));
            dispatch(GetVideoListByUser(userInfo.id));
            dispatch(GetNewVideoList(userInfo.id));
            dispatch(filterVideoList(userInfo.id, videoFilter));
            setIsInit(false);
        }
        // eslint-disable-next-line
    }, [dispatch, userInfo]);

    // ローディング完了
    useEffect(() => {
        if (!isLoading && isLoadingData && !isInit) {
            setIsLoadingData(false);
        }
        // eslint-disable-next-line
    }, [isLoading]);

    // 表示待機
    if (isLoading || isLoadingData) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    return (
        <div
            className={`${styles.root} ${
                !videoIds || videoIds?.length === 0 ? styles.noThumbsGallery : ""
            }`}
        >
            {videoIds && videoIds.length > 0 && (
                <ThumbsGallery videoList={videoIds.map((videoId) => videos[videoId])} />
            )}

            <div className={styles.slideTitle}>
                <PuiTypography
                    size={IsDevice("desktop") ? "mainTitle" : "videoTitle"}
                    color={"white"}
                >
                    おすすめのプレゼンター
                </PuiTypography>
            </div>
            {recommendProfessionalList.length > 0 ? (
                <div className={styles.slideGroup}>
                    <PresenterSlideGroup
                        id={"recommendPresenter"}
                        presenterList={recommendProfessionalList}
                        displayNum={IsDevice("desktop") ? 5 : IsDevice("ipad") ? 3 : 2}
                        needLoop={false}
                    />
                </div>
            ) : (
                <div className={styles.textNoContent} style={{ color: "var(--primary-font)" }}>
                    おすすめのプレゼンターが登録されていません
                </div>
            )}

            <div className={styles.slideTitle}>
                <PuiTypography
                    size={IsDevice("desktop") ? "mainTitle" : "videoTitle"}
                    color={"white"}
                >
                    新着動画
                </PuiTypography>
            </div>
            {newVideoList.length > 0 ? (
                <div className={styles.slideGroup}>
                    <VideoSlideGroup
                        id={"newVideo"}
                        videoListTransition={newVideoList}
                        displayNum={IsDevice("desktop") ? 5 : IsDevice("ipad") ? 3 : 2}
                        needLoop={false}
                    />
                </div>
            ) : (
                <div className={styles.textNoContent} style={{ color: "var(--primary-font)" }}>
                    新着動画がありません
                </div>
            )}

            <div className={styles.slideTitle}>
                <PuiTypography
                    size={IsDevice("desktop") ? "mainTitle" : "videoTitle"}
                    color={"white"}
                >
                    最近の視聴履歴
                </PuiTypography>
            </div>
            {userVideos.length > 0 ? (
                <div className={styles.slideGroup}>
                    <VideoSlideGroup
                        id={"viewHistory"}
                        videoListTransition={userVideos}
                        displayNum={IsDevice("desktop") ? 5 : IsDevice("ipad") ? 3 : 2}
                        needLoop={false}
                    />
                </div>
            ) : (
                <div className={styles.textNoContent} style={{ color: "var(--primary-font)" }}>
                    最近の視聴履歴がありません
                </div>
            )}
        </div>
    );
}

export default memo(HomePage);
